export const PAYMENTS = {
  REQUEST_BRAINTREE_TOKEN: 'REQUEST_BRAINTREE_TOKEN',
  SET_BRAINTREE_TOKEN: 'SET_BRAINTREE_TOKEN',
  SUBMIT_PAYMENT: 'SUBMIT_PAYMENT',
  SUBMIT_PREORDER: 'SUBMIT_PREORDER',
}
